module.exports = __webpack_public_path__ + "static/42invgde-d9a1749c575882849ce40f40669e9061.gif";